
import promotions from '~/mixins/common/pages/promotions'
export default {
    mixins: [promotions],
}
